import Icon from '../components/Icon.vue'

Icon.register({
  'map-marked-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 0c69.6 0 126 56.4 126 126 0 56.3-82.3 158.8-113.9 196-6.4 7.5-17.8 7.5-24.2 0-31.6-37.2-113.9-139.8-113.9-196 0-69.6 56.4-126 126-126zM288 168c23.2 0 42-18.8 42-42s-18.8-42-42-42-42 18.8-42 42 18.8 42 42 42zM20.1 215.9l118.6-47.5c5.2 14.9 12.4 30.4 21.3 46.4v233.1l-138.1 62.8c-10.5 4.2-21.9-3.5-21.9-14.9v-250.3c0-12 9-25.3 20.1-29.7zM288 359.7c14.1 0 27.4-6.2 36.5-17 19.7-23.2 40.6-49.6 59.5-76.7v246l-192-64v-182c18.9 27.1 39.8 53.5 59.5 76.7 9.1 10.8 22.4 17 36.5 17zM554.1 161.2c10.5-4.2 21.9 3.5 21.9 14.9v250.3c0 12-9 25.3-20.1 29.7l-139.9 56v-288z'
      }
    ]
  }
})
